const interactionNames = {
  'usCitizen-Yes': 'Citizenship toggle Yes',
  'usCitizen-No': 'Citizenship toggle No',
  'exit-link': 'Exit link',
  'contact-us-link': 'Contact Us link',
  'nav-cancel': 'Navigation cancel',
  'nav-save': 'Navigation save',
  'nav-next': 'Navigation next',
  'nav-next-error': 'Navigation next- validation error',
  'nav-previous': 'Navigation previous',
  'nav-previous-error': 'Navigation previous- validation error',
  'edit-link': 'Edit link',
  'agreement-Yes': 'Delivery toggle Yes',
  'agreement-No': 'Delivery toggle No',
  'agreement-confirm-true': 'Tax withholding Yes',
  'agreement-confirm-false': 'Tax withholding No',
  'employerAddressSame-Yes': 'Employer address same as legal: Yes toggle',
  'employerAddressSame-No': 'Employer address same as legal: No toggle',
  'successful-response': 'igo',
  'igo-response': 'IGO Response',
  'failure-response': 'nigo',
  'nigo-response': 'NIGO Response',
  'rep-chat-link': 'Rep chat link',
  'questions-link': 'Question link',
  'welcome-back-verify-identity_link': 'Verify My Identity',
  'welcome-back-exit-link': 'Welcome back exit link',
  'existingCustomer-Yes': 'Are you already a Fidelity customer:Yes toggle',
  'existingCustomer-No': 'Are you already a Fidelity customer:No toggle',
  'cash-positions-SPAXX': 'Cash position SPAXX',
  'cash-positions-FDIC': 'Cash position FDIC',
  'controlPersonToggle-No': 'Control person Question:No toggle',
  'controlPersonToggle-Yes': 'Control person Question:Yes toggle',
  detail_about_yourself: 'Details about yourself link',
  cash_position_prospect: 'Cash position prospectus link',
  cash_position_more_information: 'Cash position more information link',
  overlay_exit_link: 'Exit modal',
  billpay_link: 'Terms of use (PDF)',
  debit_link: 'Terms of use (PDF)',
  checkwriting_link: 'checkwriting signature form and terms of use (PDF)',
  overlay_close_modal: 'Close modal',
  association_help: 'Association help',
  control_person_help: 'Control person help',
  association_toggle_No: 'Association Question:No toggle',
  association_toggle_Yes: 'Association Question:Yes toggle',
  reset_password: 'Reset password',
  login_button: 'Login button',
  customer_agreements_link: 'Customer Agreements (PDF)',
  fund_prospectus_link: 'Fidelity Government Money Market Fund Prospectus',
  terms_and_conditions_link: 'Terms & Conditions (PDF)',
  brochure_supplement_link: 'Brochure Supplement(PDF)',
  trusted_contact_link: 'Trusted Contact (PDF)',
  householding_of_shareholde_link: 'Householding of Shareholder Documents (PDF)',
  electronic_delivery_agreement_link: 'Electronic Delivery Agreement (PDF)',
  SPAXX_prospectus_link: 'SPAXX prospectus',
  pre_dispute_clause_link: 'pre-dispute arbitration clause (PDF)',
  ei_section_link: 'Employment information link',
  login_disclosure_link: 'Existing Fidelity accounts',
  any_of_your_relatives: 'any of your relatives',
  need_logging_help: 'Need help logging in',
  more_info_link: 'More information',
  q_one: 'Navigation next - Success',
  q_two: 'Navigation next - Success',
  q_three: 'Navigation next - Success',
  download_link: 'Download app link',
  go_to_fidelity_link: 'Go to Fidelity link',
  'open-account-single-signer': 'Open Account Single Signer',
};

const pageNames = {
  'employment-information': 'employment info',
  'review-and-confirm': 'review & confirm',
  'personal-information': 'personal info',
  'personal-information-is': 'Personal Information',
  'review-and-confirm-is': 'Review and Confirm',
  'edit-personal-information': 'Edit personal info',
  'edit-joint-personal-information': 'Edit joint personal info',
  'edit-employment-information': 'Edit employment info',
  'edit-joint-employment-information': 'Edit joint employment info',
  'agree-to-terms': 'Agree to Terms',
  'system-error': 'System Error',
  'session-timeout': 'Session Timeout',
  'final-page': 'Final Page',
  'final-page-irrl': 'final page',
  'welcome-back': 'welcome back',
  'customer-igo': 'customer IGO',
  login: 'get started',
  'joint-personal-information': 'Joint Personal Information Page',
  'minor-login-error': 'Minor Login Error Page',
  'eligible-account-error': 'Eligible Account Error Page',
  'joint-employment-information': 'Joint Employment Information Page',
  'joint-contact-information': 'Joint Contact Information Page',
  'edit-joint-contact-information': 'Edit joint contact info',
  'identity-verification-failure': 'Identity Verification Failure',
  'trust-review-and-confirm': 'review & confirm',
  'trust-final-page': 'final page',
  'trust-information': 'Trust information',
  'open-account-single-signer': 'review & confirm',
};

const regTypeMapping = {
  rolloverIRA: 'ao:rolloverIRA',
  sepIRA: 'ao:sepIRA',
  tradIRA: 'ao:tradIRA',
  rothIRA: 'ao:rothIRA',
  brokerage: 'ao:brokerage',
  fcma: 'ao:fcma',
  iStock: 'ao:iStock',
  youth: 'ao:youth',
  trust: 'ao:trust',
};
const getRegTypeTag = (name) => regTypeMapping[name];

const getPhase = (name, flow) => {
  let phase;

  if (name === 'login' && flow === 'Individual:Prospect:Standard') {
    phase = 'ao start';
  } else if (name === 'personal-information' && flow === 'Individual:Customer:Standard') {
    phase = 'ao start';
  } else if (name === 'review-and-confirm' && flow === 'Individual:Customer:Standard') {
    phase = 'ao complete';
  } else if (name === 'review-and-confirm' && flow === 'Individual:Customer:Express') {
    phase = 'ao start, ao complete';
  }

  if (name === 'review-and-confirm' && flow === 'Individual:Prospect:Standard') {
    phase = 'ao complete';
  }
  return phase;
};
export default {
  name: 'measurement',
  methods: {
    track(name, eventType) {
      if (window.Bootstrapper && typeof window.Bootstrapper._trackAnalytics === 'function') {
        const trackObject = this.$_measurement_buildTrackObject(name, eventType);
        try {
          window.Bootstrapper._trackAnalytics(trackObject);
        } catch (err) {
          // ignore error and continue
        }
      }
    },
    trackEdit(editMode, eventName) {
      if (editMode) {
        this.track(eventName, 'pageview');
      } else {
        this.track(this.cs_stateName, 'pageview');
      }
    },
    $_measurement_buildTrackObject(name, type) {
      const pageViewParams = { pname: this.$_measurement_getPageName(name) };
      const interactionParams = { intname: this.$_measurement_getInteractionName(name) };
      const regtype = this.routeID || window.params.rt;
      if (regtype === 'managed' && this.pd_pageData.tStoreResponse && this.pd_pageData.tStoreResponse.params) {
        pageViewParams.pver = `${this.pd_pageData.tStoreResponse.params.productType}|${this.pd_pageData.tStoreResponse.params.regType}`;
        interactionParams.pver = `${this.pd_pageData.tStoreResponse.params.productType}|${this.pd_pageData.tStoreResponse.params.regType}`;
      }
      const phase = getPhase(name, this.cs_flow);
      const secVal = regtype === 'iStock' ? 'account-open-experience' : 'account opening';
      const sec1Val = regtype === 'iStock' ? 'iStock' : 'core';
      const obj = {
        pt: 'ao ss',
        channel: 'Fid.com web',
        sec: secVal,
        sec1: sec1Val,
        action: type,
        loc: 'web',
        flowtype: this.cs_flow,
        regtype: getRegTypeTag(regtype),
        ...(type === 'pageview' && pageViewParams),
        ...(type === 'interaction' && interactionParams),
      };
      if (phase) {
        obj.phase = phase;
      }
      return obj;
    },
    $_measurement_getPageName(name) {
      return pageNames[name] || 'err_pagename_not_found';
    },
    $_measurement_getInteractionName(name) {
      let interaction = interactionNames[name] || 'err_intname_not_found';
      if (name === 'overlay_exit_link') {
        interaction += ` - ${pageNames[this.cs_stateNamne]}`;
      }
      return interaction;
    },
  },
};
